import React, { FC } from "react";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { RouterParamType } from "@/model/navModel";
import { BaseDetail } from "./base";
import { RelevanceTask } from "./task";
import { Files } from "./files";
import { MaterialInfo } from "./info";
import { ISalesTabEnum } from "../../salesTypes";
import { useSalesDetailModel } from "./salesDetailModel";
import { LogisticsProcess } from "./process";
import { AuditDetail } from "./audit";

export const TabBar: FC<RouterParamType> = (detailsInfo) => {
    const { tabActive, setTabActive } = useSalesDetailModel(({ tabActive }) => [tabActive]);
    const isEdit = detailsInfo.mode === "edit";
    //防止保存是表单拿不到， 在下面渲染
    const RenderTabItem = () => {
        switch (tabActive) {
            // case ISalesTabEnum.BASE_DETAIL:
            //     return <BaseDetail {...detailsInfo}/>;
            case ISalesTabEnum.MATERIAL_INFO:
                return <MaterialInfo {...detailsInfo} />;
            case ISalesTabEnum.RELEVANCE_TASK:
                return <RelevanceTask {...detailsInfo} />;
            case ISalesTabEnum.FILES:
                return <Files {...detailsInfo} />;
            case ISalesTabEnum.LOGISTICS_PROCESS:
                return <LogisticsProcess {...detailsInfo} />;
            case ISalesTabEnum.AUDIT_DETAIL:
                return <AuditDetail {...detailsInfo} />;
            default:
                return <></>
        }
    }

    const classname = (type: ISalesTabEnum) => {
        return 'tab-item ' + (tabActive === type ? 'tab-active' : '')
    }

    const action = <>
        <Button
            className={classname(ISalesTabEnum.BASE_DETAIL)}
            type="link"
            shape="round"
            onClick={() => setTabActive(ISalesTabEnum.BASE_DETAIL)}
        >基本信息</Button>
        <Button
            className={classname(ISalesTabEnum.MATERIAL_INFO)}
            type="link"
            shape="round"
            onClick={() => setTabActive(ISalesTabEnum.MATERIAL_INFO)}
        >商品信息</Button>
        <Button
            className={classname(ISalesTabEnum.RELEVANCE_TASK)}
            type="link"
            shape="round"
            hidden={!isEdit}
            onClick={() => setTabActive(ISalesTabEnum.RELEVANCE_TASK)}
        >关联单据</Button>
        <Button
            className={classname(ISalesTabEnum.FILES)}
            type="link"
            shape="round"
            hidden={!isEdit}
            onClick={() => setTabActive(ISalesTabEnum.FILES)}
        >附件管理</Button>
        <Button
            className={classname(ISalesTabEnum.LOGISTICS_PROCESS)}
            type="link"
            shape="round"
            hidden={!isEdit}
            onClick={() => setTabActive(ISalesTabEnum.LOGISTICS_PROCESS)}
        >物流进程</Button>
        <Button
            className={classname(ISalesTabEnum.AUDIT_DETAIL)}
            type="link"
            shape="round"
            hidden={!isEdit}
            onClick={() => setTabActive(ISalesTabEnum.AUDIT_DETAIL)}
        >审批明细</Button>
    </>

    return (
        <>
            <YhBox
                style={{ paddingBottom: 0, marginBottom: "10px" }}
                action={action}
            />
            <div hidden={tabActive !== ISalesTabEnum.BASE_DETAIL}><BaseDetail {...detailsInfo} /></div>
            <RenderTabItem />
        </>
    )
}